import { useStaffPersona } from '@features/personas/queries'

export function useConversationStaffName(initials: string, fallback = initials) {
    const { data } = useStaffPersona({ identifier: initials, identifierType: 'initials' })
    return data ? `${data.firstName} ${data.surname}` : fallback
}
